// Mapping oficial Distritos -> Barrios de Terrassa
export const DISTRITOS_BARRIOS = {
  "Distrito 1 (Centre)": [
    "Centre",
    "Plaça Catalunya - Escola Industrial",
    "Barri Universitari - Cementiri Vell",
    "Vallparadís",
    "Antic Poble de Sant Pere",
  ],
  "Distrito 2 (Est)": [
    "Ca n'Anglada",
    "Montserrat",
    "Torre-sana",
    "Vilardell",
  ],
  "Distrito 3 (Sud)": [
    "Can Palet",
    "Segle XX",
    "Can Jofresa",
    "Guadalhorce",
    "Xúquer",
    "Can Palet II",
  ],
  "Distrito 4 (Oest)": [
    "Ca n'Aurell",
    "La Maurina",
    "Roc Blanc",
    "La Cogullada",
  ],
  "Distrito 5 (Nord-oest)": [
    "Poble Nou - Zona Esportiva",
    "Sant Pere",
    "Can Boada Casc Antic",
    "Torrent d'en Pere Parres",
    "Can Boada del Pi",
    "Can Roca",
    "Pla del Bon Aire",
    "Pla del Bon Aire - El Garrot",
    "Els Caus - els Pinetons",
  ],
  "Distrito 6 (Nord-est)": [
    "Sant Pere Nord",
    "Les Arenes, la Grípia i Can Montllor",
    "Sant Llorenç",
    "Ègara",
    "Can Tusell",
  ],
  "Distrito 7": [
    "Can Parellada",
    "Les Fonts",
  ],
  "Disseminats": [
    "Can Palet de Vista Alegre",
    "Les Martines",
    "Les Carbonelles",
    "Vista Alegre",
    "Can Gonteres",
    "La Font de l'Espardenyera",
    "El Molinot",
  ],
};

export const DISTRITOS = Object.keys(DISTRITOS_BARRIOS);

export const COLUMNAS_EXPORT = [
  { key: "nombre", label: "Nombre" },
  { key: "apellidos", label: "Apellidos" },
  { key: "dni", label: "DNI" },
  { key: "direccion", label: "Dirección" },
  { key: "telefono", label: "Teléfono" },
  { key: "email", label: "Email" },
  { key: "instagram", label: "Instagram" },
  { key: "facebook", label: "Facebook" },
  { key: "cumpleanos", label: "Cumpleaños" },
  { key: "es_apoderado", label: "Apoderado" },
  { key: "anios_apoderado", label: "Años apoderado" },
  { key: "fecha_baja_apoderado", label: "Fecha baja apoderado" },
  { key: "es_afiliado", label: "Afiliado" },
  { key: "numero_afiliado", label: "Nº afiliado" },
  { key: "fecha_alta_afiliado", label: "Fecha alta afiliado" },
  { key: "fecha_baja_afiliado", label: "Fecha baja afiliado" },
  { key: "iban", label: "IBAN" },
  { key: "permite_publicidad", label: "Permite publicidad" },
  { key: "permite_whatsapp", label: "Publicidad WhatsApp" },
  { key: "distrito", label: "Distrito" },
  { key: "barrio", label: "Barrio" },
  { key: "tema", label: "Tema" },
  { key: "es_referente_territorio", label: "Referente Territorio" },
  { key: "es_voluntario", label: "Voluntari 2027" },
  { key: "voluntari_hoja_alta", label: "Hoja de alta voluntario" },
  { key: "voluntari_disponibilitat", label: "Disponibilitat horària" },
  { key: "voluntari_horari_observacions", label: "Observacions horari" },
  { key: "voluntari_equip", label: "Equip" },
  { key: "voluntari_actes", label: "Voluntariat en actes" },
  { key: "pertenece_consell_sectorial", label: "Consell sectorial" },
  { key: "consells_sectorials", label: "Consells sectorials" },
  { key: "pertenece_consell_districte", label: "Consell districte" },
  { key: "consells_districte", label: "Districtes del consell" },
  { key: "comentaris", label: "Comentaris" },
];

export const CONSELLS_SECTORIALS = [
  "Seguretat",
  "Cultura i arts",
  "Formació professional",
  "Esports",
  "Serveis públics com. audiovisual",
  "Medi ambient",
  "Eco. social i solidària",
  "Salut",
  "Serveis socials",
  "Universitari",
  "Neteja i residus",
  "Habitatge",
  "Gent gran",
  "Escolar",
  "Solidaritat i coop. intern.",
  "Infància i adolescència",
  "Per la llengua catalana",
  "Taula mobilitat",
  "RULC",
  "Taula treball turisme",
  "Taula local capac. diverses i accessibilitat",
  "Taula seguiment rieres",
  "Observatori aigua",
];

export const CONSELLS_DISTRICTE = ["D1", "D2", "D3", "D4", "D5", "D6", "D7"];

// Voluntariat 2027: disponibilitat horària
export const FRANJAS_HORARIAS = [
  { key: "mati", label: "Matí" },
  { key: "tarda", label: "Tarda" },
  { key: "vespre", label: "Vespre" },
];

export const DIES_SEMANA = [
  { key: "dl", label: "Dl" },
  { key: "dt", label: "Dt" },
  { key: "dc", label: "Dc" },
  { key: "dj", label: "Dj" },
  { key: "dv", label: "Dv" },
  { key: "ds", label: "Ds" },
  { key: "dg", label: "Dg" },
];

// Voluntariat 2027: actes concrets on es pot col·laborar
export const VOLUNTARI_ACTES = [
  "Tardor: Sortida a muntanya",
  "13 novembre: Gran Recapte 2026",
  "Gener: Any nou Festa cultural – musical",
  "12 febrer: Xocolatada solidària",
  "Febrer: Carnestoltes",
  "Març: dinar/sopar de dones 8M",
  "23 abril: Sant Jordi",
  "4 maig: acte Centre Cultural",
  "6 maig: acte inici campanya + penjada cartells",
];

export const TEMAS = [
  "cultura",
  "llengua",
  "educació",
  "salud",
  "juventut i infancia",
  "esport",
  "veïnals",
  "política",
  "religió",
  "medi ambient",
  "gent gran",
  "feminisme",
  "internacional",
  "benestar animal",
  "altres",
];

// Detección de fechas "reales" (descarta sentinelas tipo 0001-01-01 y similares)
export const isRealDate = (s) => {
  if (!s) return false;
  const str = String(s).trim();
  if (!str) return false;
  const m = str.match(/(\d{4})/);
  if (!m) return false;
  const year = parseInt(m[1], 10);
  return year >= 1900 && year <= 2100;
};

// Normaliza una fecha: si no es real, devuelve cadena vacía
export const normalizeDate = (s) => (isRealDate(s) ? String(s).trim() : "");
